import { useState, useMemo, ReactNode, useEffect } from 'react';
import ChartContext, { ChartTotalProps } from './ChartContext';

interface ChartProviderProps {
  children: ReactNode;
};

function ChartProvider({children}: ChartProviderProps) {
  const [chartTotal, setChartTotal] = useState<ChartTotalProps>(() => {
    const storedQuantity = sessionStorage.getItem('chartTotal');
    return storedQuantity
      ? JSON.parse(storedQuantity)
      : { itemsTotal: 0, priceTotal: 0 };
  });

  useEffect(() => {
    sessionStorage.setItem('chartTotal', JSON.stringify(chartTotal));
  }, [chartTotal]);
  
  const chartContextValues = useMemo(() => ({
    chartTotal,
    setChartTotal,
  }), [chartTotal]);
  
  return (
    <ChartContext.Provider value={ chartContextValues }>
      {children}
    </ChartContext.Provider>
  )
}

export default ChartProvider;